import React from 'react'
import {
  FiltersContainer,
  FilterField,
  FilterInput,
  FilterLabel
} from './EstimateFilters.styles'

interface EstimateFiltersProps {
  contractor: string
  oipd: string
  article: string
  contractNumber: string
  actNumber: string
  onContractorChange: (value: string) => void
  onOipdChange: (value: string) => void
  onArticleChange: (value: string) => void
  onContractNumberChange: (value: string) => void
  onActNumberChange: (value: string) => void
}

export const EstimateFilters: React.FC<EstimateFiltersProps> = ({
  contractor,
  oipd,
  article,
  contractNumber,
  actNumber,
  onContractorChange,
  onOipdChange,
  onArticleChange,
  onContractNumberChange,
  onActNumberChange
}) => {
  return (
    <FiltersContainer>
      <FilterField>
        <FilterLabel>Подрядчик</FilterLabel>
        <FilterInput
          type="text"
          placeholder="Наименование подрядчика"
          value={contractor}
          onChange={e => onContractorChange(e.target.value)}
        />
      </FilterField>
      <FilterField>
        <FilterLabel>Объект ИПД</FilterLabel>
        <FilterInput
          type="text"
          placeholder="Адрес ОИПД"
          value={oipd}
          onChange={e => onOipdChange(e.target.value)}
        />
      </FilterField>
      <FilterField>
        <FilterLabel>Статьи бюджета</FilterLabel>
        <FilterInput
          type="text"
          placeholder="05, 06, 12"
          value={article}
          onChange={e => onArticleChange(e.target.value)}
        />
      </FilterField>
      <FilterField>
        <FilterLabel>Номер договора/д.с.</FilterLabel>
        <FilterInput
          type="text"
          placeholder="Номер договора/д.с."
          value={contractNumber}
          onChange={e => onContractNumberChange(e.target.value)}
        />
      </FilterField>
      <FilterField>
        <FilterLabel>Номер акта</FilterLabel>
        <FilterInput
          type="text"
          placeholder="Номер акта"
          value={actNumber}
          onChange={e => onActNumberChange(e.target.value)}
        />
      </FilterField>
    </FiltersContainer>
  )
}
